module.exports = __webpack_public_path__ + "static/media/welcome-activity.82c3cbfc.png";